<template>
    <div class="template-charts-area">
        <slot>
            <!-- 기본 플레이스홀더 차트 영역 (2x2 Grid) -->
            <div v-for="i in 4" :key="i" class="chart-placeholder">
                <div class="chart-label">차트 영역 {{ i }}</div>
                <div class="chart-content">차트 내용을 여기에 표시합니다</div>
            </div>
        </slot>
    </div>
</template>

<script>
export default {
    name: "TemplateChartsArea",
};
</script>

<style scoped>
.template-charts-area {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    height: 100%;
}

.chart-placeholder {
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    min-height: 200px;
}

.chart-label {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e2e8f0;
}

.chart-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    font-size: 12px;
    background: #f8fafc;
    border-radius: 6px;
    border: 1px dashed #cbd5e1;
}
</style>
